/* JSON Web Tokens that are used as authentication header. */

export function authHeader() {
    // return authorization header with jwt token
    let user = JSON.parse(localStorage.getItem('user'));

    if (user && user.userTokens && user.userTokens.accessToken) {
        return { 'Authorization': 'Bearer ' + user.userTokens.accessToken };
    } else {
        return {};
    }
}